import { render, staticRenderFns } from "./TipoAcaoLateral.vue?vue&type=template&id=2373110a&lang=html&"
import script from "./TipoAcaoLateral.vue?vue&type=script&lang=js&"
export * from "./TipoAcaoLateral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/tipo-acao/TipoAcaoLateral.vue
// module id = 1522
// module chunks = 28